"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunitySearchResultsCountDto = instanceOfOrientationOpportunitySearchResultsCountDto;
exports.OrientationOpportunitySearchResultsCountDtoFromJSON = OrientationOpportunitySearchResultsCountDtoFromJSON;
exports.OrientationOpportunitySearchResultsCountDtoFromJSONTyped = OrientationOpportunitySearchResultsCountDtoFromJSONTyped;
exports.OrientationOpportunitySearchResultsCountDtoToJSON = OrientationOpportunitySearchResultsCountDtoToJSON;
exports.OrientationOpportunitySearchResultsCountDtoToJSONTyped = OrientationOpportunitySearchResultsCountDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunitySearchResultsCountDto interface.
 */
function instanceOfOrientationOpportunitySearchResultsCountDto(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
function OrientationOpportunitySearchResultsCountDtoFromJSON(json) {
    return OrientationOpportunitySearchResultsCountDtoFromJSONTyped(json, false);
}
function OrientationOpportunitySearchResultsCountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
    };
}
function OrientationOpportunitySearchResultsCountDtoToJSON(json) {
    return OrientationOpportunitySearchResultsCountDtoToJSONTyped(json, false);
}
function OrientationOpportunitySearchResultsCountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
    };
}
//# sourceMappingURL=OrientationOpportunitySearchResultsCountDto.js.map